import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardIcon'
})
export class CardIconPipe implements PipeTransform {
  transform(value: any): any {
    switch (value) {
      case 'American Express':
        return 'fa-cc-amex';
      case `Diner's Club`:
      case `Diners`:
        return 'fa-cc-diners-club';
      case 'Discovery':
      case 'Discover Card':
        return 'fa-cc-discover';
      case 'MasterCard':
        return 'fa-cc-mastercard';
      case 'Visa':
        return 'fa-cc-visa';
      default:
        return 'fa-credit-card';
    }
  }
}
